import apiService from './apiService';

class GandiService {
  constructor() {
    this.isConfiguredFlag = apiService.isConfigured();
  }

  // Vérifier si le service est configuré
  isConfigured() {
    return this.isConfiguredFlag;
  }

  // Récupérer la liste des domaines Gandi
  async getDomains() {
    try {
      const response = await apiService.get('/gandi/domains');
      return response.domains || response.data || [];
    } catch (error) {
      console.error('Erreur lors de la récupération des domaines Gandi:', error);
      throw error;
    }
  }

  // Récupérer les détails d'un domaine Gandi spécifique
  async getDomainDetails(domainId) {
    try {
      const response = await apiService.get(`/gandi/domains/${domainId}`);
      return response.data || response;
    } catch (error) {
      console.error(`Erreur lors de la récupération des détails du domaine Gandi ${domainId}:`, error);
      throw error;
    }
  }

  // Récupérer toutes les informations d'un domaine Gandi
  async getDomainFullInfo(domainId) {
    try {
      const details = await this.getDomainDetails(domainId);
      return {
        ...details,
        error: null
      };
    } catch (error) {
      console.error(`Erreur lors de la récupération des informations complètes du domaine Gandi ${domainId}:`, error);
      return {
        id: domainId,
        error: error.message
      };
    }
  }

  // Récupérer les informations de tous les domaines Gandi
  async getAllDomainsInfo() {
    try {
      const domains = await this.getDomains();
      const domainsInfo = await Promise.all(
        domains.map(async (domain) => {
          try {
            const info = await this.getDomainFullInfo(domain.id);
            return {
              ...domain,
              ...info
            };
          } catch (error) {
            console.error(`Erreur pour le domaine Gandi ${domain.id}:`, error);
            return {
              ...domain,
              error: error.message
            };
          }
        })
      );

      return domainsInfo;
    } catch (error) {
      console.error('Erreur lors de la récupération de tous les domaines Gandi:', error);
      throw error;
    }
  }

  // Méthode pour tester la connexion API
  async testConnection() {
    try {
      const response = await apiService.get('/gandi/test');
      return {
        success: true,
        data: response
      };
    } catch (error) {
      return {
        success: false,
        error: error.message
      };
    }
  }

  // Synchroniser les domaines Gandi
  async syncDomains() {
    try {
      const response = await apiService.post('/gandi/sync', null, {}, { timeout: 600000 });
      return response;
    } catch (error) {
      console.error('Erreur lors de la synchronisation des domaines Gandi:', error);
      throw error;
    }
  }
}

// Créer une instance singleton du service
const gandiService = new GandiService();

export default gandiService;
